export default "__VITE_ASSET__2lIIL9$X__"